var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "filter-container" }, [
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("newOrder.createTime"))),
            ]),
            _c("el-date-picker", {
              staticStyle: { width: "300px" },
              attrs: {
                clearable: false,
                "default-time": ["00:00:00", "23:59:59"],
                format: _vm.$i18n.locale == "zh" ? _vm.zhDate : _vm.ptDate,
                placeholder: _vm.$t("newOrder.SelectDatetime"),
                "range-separator": "~",
                type: "datetimerange",
                "value-format": "yyyy-MM-dd HH:mm:ss",
              },
              model: {
                value: _vm.timeValue,
                callback: function ($$v) {
                  _vm.timeValue = $$v
                },
                expression: "timeValue",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("newOrder.CustomerName"))),
            ]),
            _c(
              "el-select",
              {
                attrs: {
                  placeholder: _vm.$t("GlobalSetObj.OnlyAreDisplayed"),
                  "remote-method": _vm.getCustomerPage,
                  clearable: "",
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                },
                on: {
                  focus: function ($event) {
                    return _vm.getCustomerPage("")
                  },
                },
                model: {
                  value: _vm.queryParams.customerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "customerId", $$v)
                  },
                  expression: "queryParams.customerId",
                },
              },
              _vm._l(_vm.customerList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: {
                    label: item.customerAlias + "（" + item.username + "）",
                    value: item.id,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("newOrder.SenderState"))),
            ]),
            _c(
              "el-select",
              {
                attrs: {
                  placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                  clearable: "",
                  filterable: "",
                  multiple: "",
                },
                model: {
                  value: _vm.queryParams.senderStateList,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "senderStateList", $$v)
                  },
                  expression: "queryParams.senderStateList",
                },
              },
              _vm._l(_vm.StateList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.label, value: item.label },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter-actions" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  icon: "el-icon-search",
                  size: "small",
                  type: "primary",
                },
                on: { click: _vm.getSearch },
              },
              [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleReset } },
              [_vm._v(_vm._s(_vm.$t("newOrder.reset")))]
            ),
            _c(
              "el-radio-group",
              {
                staticStyle: { margin: "0 10px" },
                attrs: { size: "small" },
                model: {
                  value: _vm.queryParams.isTest,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "isTest", $$v)
                  },
                  expression: "queryParams.isTest",
                },
              },
              [
                _c("el-radio-button", { attrs: { label: 1 } }, [
                  _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                ]),
                _c("el-radio-button", { attrs: { label: 2 } }, [
                  _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                ]),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: {
                  icon: "el-icon-upload2",
                  size: "small",
                  type: "primary",
                },
                on: { click: _vm.exportFun },
              },
              [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-row",
        { staticClass: "summary-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 7 } }, [
            _c("div", { staticClass: "stat-card summary-card border-green" }, [
              _c("div", { staticClass: "card-title text-green" }, [
                _vm._v(_vm._s(_vm.$t("tablePrice.realtimeTotal"))),
              ]),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "main-stat" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.pendingPickupTotal"))),
                  ]),
                  _c("span", { staticClass: "stat-number text-red" }, [
                    _vm._v(_vm._s(_vm.resultData.totalQuantity || 0)),
                  ]),
                ]),
                _c("div", { staticClass: "sub-stat bg-pink" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("tablePrice.todayNewPendingPickup"))),
                  ]),
                  _c("span", { staticClass: "text-red font-bold" }, [
                    _vm._v("+" + _vm._s(_vm.resultData.today || 0)),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 4 } }, [
            _c(
              "div",
              { staticClass: "stat-card warn-card border-red bg-pink" },
              [
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "warn-label" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.over7Days"))),
                  ]),
                  _c("div", { staticClass: "warn-desc" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.notPickedUpCount"))),
                  ]),
                  _c("div", { staticClass: "warn-number text-red" }, [
                    _vm._v(_vm._s(_vm.resultData.overSevenDays || 0)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 4 } }, [
            _c(
              "div",
              { staticClass: "stat-card warn-card border-red bg-pink" },
              [
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "warn-label" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.within7DaysTo3DaysAgo"))),
                  ]),
                  _c("div", { staticClass: "warn-desc" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.notPickedUpCount"))),
                  ]),
                  _c("div", { staticClass: "warn-number text-red" }, [
                    _vm._v(_vm._s(_vm.resultData.threeDaysBefore || 0)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 4 } }, [
            _c(
              "div",
              { staticClass: "stat-card warn-card border-red bg-pink" },
              [
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "warn-label" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.within3DaysTo1DayAgo"))),
                  ]),
                  _c("div", { staticClass: "warn-desc" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.notPickedUpCount"))),
                  ]),
                  _c("div", { staticClass: "warn-number text-red" }, [
                    _vm._v(_vm._s(_vm.resultData.oneDaysBefore || 0)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 5 } }, [
            _c(
              "div",
              {
                staticClass: "stat-card warn-card border-green bg-light-green",
              },
              [
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "warn-label" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.currentDay"))),
                  ]),
                  _c("div", { staticClass: "warn-desc" }, [
                    _vm._v(_vm._s(_vm.$t("tablePrice.notPickedUpCount"))),
                  ]),
                  _c("div", { staticClass: "warn-number text-green" }, [
                    _vm._v(_vm._s(_vm.resultData.today || 0)),
                  ]),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "region-section" },
        [
          _c("div", { staticClass: "section-header text-green font-bold" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("tablePrice.pendingPickupByRegion")) + " "
            ),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            _vm._l(_vm.regionData, function (item, index) {
              return _c(
                "el-col",
                {
                  key: index,
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { span: 6 },
                },
                [
                  _c("div", { staticClass: "region-card border-green" }, [
                    _c("div", { staticClass: "region-name font-bold" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("div", { staticClass: "region-stat" }, [
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("tablePrice.pendingPickupWaybillPackage")
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "stat-number text-green" }, [
                        _vm._v(_vm._s(item.pendingCount)),
                      ]),
                    ]),
                    _c("div", { staticClass: "region-stat" }, [
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("tablePrice.orderCustomerCount"))),
                      ]),
                      _c("span", { staticClass: "stat-number text-green" }, [
                        _vm._v(_vm._s(item.customerCount)),
                      ]),
                    ]),
                    item.customerCount > 0 || item.pendingCount > 0
                      ? _c("div", { staticClass: "region-footer" }, [
                          _c("i", {
                            staticClass: "el-icon-bottom text-green",
                            on: {
                              click: function ($event) {
                                return _vm.handleExport(item)
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }